import React from 'react';

export default function Input({ label, type, onChange, value, maxLength }){
  const iType = type || 'text';
  return <div className="input">
    <label>{label}</label>
    <input type={iType} value={value} onChange={onChange} maxLength={maxLength}/>
  </div>
}